<template>
  <div>
    <div v-if="loading" style="padding:20px">
      <div class="ui active centered inline large loader"></div>
    </div>
    <div v-else class="ui grid" style="padding:20px">
      <div class="row">
        <div class="six wide column">
          <div class="ui header">Configuration</div>
        </div>
      </div>
      <div class="row">
        <div class="fourteen wide column">
          <div class="ui form">
            <div class="field">
              <div class="ui checkbox labelCursorFix">
                <input type="checkbox" data-lpignore="true" v-model="alertOnCategoryTypeNameChange" id="checkbox312455">
                <label for="checkbox312455">
                  Main Category: Alert if Product Type changes
                </label>
              </div>
            </div>
            <div class="field">
              <div class="ui checkbox labelCursorFix">
                <input type="checkbox" data-lpignore="true" v-model="alertOnCategoryGroupChange" id="checkbox312456">
                <label for="checkbox312456">
                  Main Category: Alert if Product Group changes
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="six wide column">
          <button v-bind:class="dirty ? 'ui primary button' : 'ui disabled primary button'" v-on:click="save()">Save</button>
          <button class="ui basic button" @click="close()">Close </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      loading: true,
      alertOnCategoryGroupChange: false,
      alertOnCategoryTypeNameChange: false,
      alertOnCategoryGroupChangeOrig: false,
      alertOnCategoryTypeNameChangeOrig: false,
      dirty: false,
    }
  },
  methods: {
    load: function () {
      this.$http.get('/api/sentinel/watchdogtype/settings/productCategoryRecentChange').then((response) => {
        this.loading = false
        this.alertOnCategoryGroupChangeOrig = this.alertOnCategoryGroupChange = response.body.alertOnCategoryGroupChange
        this.alertOnCategoryTypeNameChangeOrig = this.alertOnCategoryTypeNameChange = response.body.alertOnCategoryTypeNameChange
      }, (response) => {
        this.loading = false
      })
    },
    close: function () {
      this.$parent.showConfiguration = false
    },
    save: function () {
      this.$http.put('/api/sentinel/watchdogtype/settings/productCategoryRecentChange', {
        alertOnCategoryGroupChange: this.alertOnCategoryGroupChange,
        alertOnCategoryTypeNameChange: this.alertOnCategoryTypeNameChange,
      }).then((response) => {
        this.alertOnCategoryGroupChangeOrig = this.alertOnCategoryGroupChange
        this.alertOnCategoryTypeNameChangeOrig = this.alertOnCategoryTypeNameChange
        this.updateDirty()
      }, (response) => {
        this.loading = false
      })
    },
    updateDirty: function () {
      this.dirty = this.alertOnCategoryGroupChange !== this.alertOnCategoryGroupChangeOrig || this.alertOnCategoryTypeNameChange !== this.alertOnCategoryTypeNameChangeOrig
    }
  },
  created: function () {
    this.load()
  },
  watch: {
    alertOnCategoryGroupChange: function () {
      this.updateDirty()
    },
    alertOnCategoryTypeNameChange: function () {
      this.updateDirty()
    },
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// CategoryChangeConfig.vue?c6873490